import React, { useState } from 'react';
import {
    CARD_DISPLAY_MODE,
    CARD_DISPLAY_MODE_LABELS,
    CARD_SIDE_TYPE_LABELS
} from '../constants/learning-cards';

const STORAGE_KEY_CARDS_COUNT = 'testCardsCount';
const STORAGE_KEY_DISPLAY_MODE = 'testDisplayMode';
const DEFAULT_CARDS_COUNT = 15;

function StartTestModal({ show, group, groupId, onClose, onTestStart }) {
    const [cardsCount, setCardsCount] = useState(() => {
        const saved = localStorage.getItem(STORAGE_KEY_CARDS_COUNT);
        return saved ? parseInt(saved, 10) : DEFAULT_CARDS_COUNT;
    });

    const [displayMode, setDisplayMode] = useState(() => {
        const saved = localStorage.getItem(STORAGE_KEY_DISPLAY_MODE);
        return saved || CARD_DISPLAY_MODE.SIDE_1_AS_FRONT;
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleCardsCountChange = (e) => {
        const value = parseInt(e.target.value, 10);
        if (!isNaN(value) && value > 0) {
            setCardsCount(value);
            localStorage.setItem(STORAGE_KEY_CARDS_COUNT, value.toString());
        }
    };

    const handleDisplayModeChange = (e) => {
        const value = e.target.value;
        setDisplayMode(value);
        localStorage.setItem(STORAGE_KEY_DISPLAY_MODE, value);
    };

    const handleStartTest = async () => {
        setError('');
        setLoading(true);

        try {
            if (onTestStart) {
                await onTestStart(cardsCount, displayMode);
            }
        } catch (err) {
            setError('Failed to start test. Please try again.');
            console.error('Start test error:', err);
            setLoading(false);
        }
    };

    if (!show) return null;

    console.log('StartTestModal group:', group); // Debug log
    const groupCardSideTypes = group?.cardSideTypes || group?.card_side_types || [];
    console.log('Group card side types:', groupCardSideTypes); // Debug log

    const side1Type = groupCardSideTypes[0] || 'CARD_SIDE_NULL';
    const side2Type = groupCardSideTypes[1] || 'CARD_SIDE_NULL';
    const side1Label = CARD_SIDE_TYPE_LABELS[side1Type] || 'Standard';
    const side2Label = CARD_SIDE_TYPE_LABELS[side2Type] || 'Standard';

    console.log('Side types:', { side1Type, side2Type, side1Label, side2Label }); // Debug log

    return (
        <>
            <div
                className="modal-backdrop fade show"
                style={{ zIndex: 1040 }}
                onClick={onClose}
            ></div>

            <div
                className="modal fade show d-block"
                tabIndex="-1"
                role="dialog"
                style={{ zIndex: 1050 }}
            >
                <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                    style={{ pointerEvents: 'auto' }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Start Test</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                                aria-label="Close"
                                disabled={loading}
                            ></button>
                        </div>

                        <div className="modal-body">
                            {error && (
                                <div className="alert alert-danger" role="alert">
                                    {error}
                                </div>
                            )}

                            <div className="mb-4">
                                <label htmlFor="cardsCount" className="form-label">
                                    Maximum number of cards
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    id="cardsCount"
                                    min="1"
                                    max="100"
                                    value={cardsCount}
                                    onChange={handleCardsCountChange}
                                    disabled={loading}
                                />
                                <div className="form-text">
                                    Choose how many cards you want to practice (1-100)
                                </div>
                            </div>

                            <div className="mb-4">
                                <label htmlFor="displayMode" className="form-label">
                                    Which side to show first
                                </label>
                                <select
                                    className="form-select"
                                    id="displayMode"
                                    value={displayMode}
                                    onChange={handleDisplayModeChange}
                                    disabled={loading}
                                >
                                    <option value={CARD_DISPLAY_MODE.SIDE_1_AS_FRONT}>
                                        Side 1 - {side1Label}
                                    </option>
                                    <option value={CARD_DISPLAY_MODE.SIDE_2_AS_FRONT}>
                                        Side 2 - {side2Label}
                                    </option>
                                </select>
                                <div className="form-text">
                                    Choose which side of the cards will be shown first in the test.
                                    This setting will be remembered for future tests.
                                </div>
                            </div>

                            <div className="alert alert-info" role="alert">
                                <strong>Test Mode:</strong> You'll see cards one by one and can mark your confidence level for each answer.
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={onClose}
                                disabled={loading}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleStartTest}
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Starting...
                                    </>
                                ) : (
                                    'Start Test'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StartTestModal;